import { render, staticRenderFns } from "./CheckVinBar.vue?vue&type=template&id=bb58676c&scoped=true"
import script from "./CheckVinBar.vue?vue&type=script&lang=js"
export * from "./CheckVinBar.vue?vue&type=script&lang=js"
import style0 from "./CheckVinBar.vue?vue&type=style&index=0&id=bb58676c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb58676c",
  null
  
)

export default component.exports